/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ask_A_Question_1Inputs */

const en_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask a question...`)
};

const es_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz una pregunta...`)
};

const fr_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posez une question...`)
};

const de_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle eine Frage...`)
};

const ja_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`質問する...`)
};

const zh_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提问...`)
};

const ar_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسأل سؤالاً...`)
};

const id_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajukan pertanyaan...`)
};

const it_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai una domanda...`)
};

const ru_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задайте вопрос...`)
};

const pt_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça uma pergunta...`)
};

const ko_ask_a_question_1 = /** @type {(inputs: Ask_A_Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`질문하기...`)
};

/**
* | output |
* | --- |
* | "Ask a question..." |
*
* @param {Ask_A_Question_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ask_a_question_1 = /** @type {((inputs?: Ask_A_Question_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ask_A_Question_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ask_a_question_1(inputs)
	if (locale === "es") return es_ask_a_question_1(inputs)
	if (locale === "fr") return fr_ask_a_question_1(inputs)
	if (locale === "de") return de_ask_a_question_1(inputs)
	if (locale === "ja") return ja_ask_a_question_1(inputs)
	if (locale === "zh") return zh_ask_a_question_1(inputs)
	if (locale === "ar") return ar_ask_a_question_1(inputs)
	if (locale === "id") return id_ask_a_question_1(inputs)
	if (locale === "it") return it_ask_a_question_1(inputs)
	if (locale === "ru") return ru_ask_a_question_1(inputs)
	if (locale === "pt") return pt_ask_a_question_1(inputs)
	return ko_ask_a_question_1(inputs)
});